import { Box, Button, Column } from '@dixa/lib-shared-habla';
import { useKey } from 'react-use';

import { ConversationPreview } from 'components/conversation/conversationPreview';

type ConversationScopeListPreviewProps = {
  /** The id of the conversation to preview. */
  readonly csid: number;
  /** Called when going back to the search results. */
  readonly onBack: VoidFunction;
  /** Called when navigating to the conversation. */
  readonly onNavigateToConversation: VoidFunction;
};

/** Previews a conversation inline in the command launcher. */
export const ConversationScopeListPreview = ({
  csid,
  onBack,
  onNavigateToConversation,
}: ConversationScopeListPreviewProps): JSX.Element => {
  // Backspace in the search input goes back to the list instead of editing the query.
  useKey(
    (event) =>
      event.key === 'Backspace' &&
      event.target instanceof HTMLElement &&
      event.target.hasAttribute('data-command-launcher-input'),
    (event) => {
      event.preventDefault();
      onBack();
    },
    { event: 'keydown' },
    [onBack],
  );

  return (
    <Column.Row size={1} noHorizontalPadding noVerticalPadding noMinHeight>
      <Box padding="250 250 0">
        <Button variant="tertiary" icon="arrow-left" onClick={onBack}>
          Back to results
        </Button>
      </Box>

      <ConversationPreview
        csid={csid}
        onNavigateToConversation={onNavigateToConversation}
      />
    </Column.Row>
  );
};
